import { authHeader } from "../../../helpers/authHeader";
import axios from "axios";


export default {
    get,
    getEmployees,
    getEvents,
    saveEvents,
    clockIn,
    clockOut,
    loadAdminClocks,
    load,
    save,
    newClock,
};


function get() {
    const requestOptions = {
        headers: Object.assign(authHeader(),{'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*'}),
    };

    return axios.get(process.env.REACT_APP_COORDINATOR_URL+'/api/clock',  requestOptions)
        .then(response => {
            return response.data.data;
        }, handleError);
}


function getEmployees() {
    const requestOptions = {
        headers: Object.assign(authHeader(), {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        }),
    };

    return axios.get(process.env.REACT_APP_COORDINATOR_URL+"/api/clock/employees", requestOptions)
        .then(response => {
            return response.data.data;
        }, handleError);
}

function getEvents(warehouse_id, start, end) {
    const requestOptions = {
        headers: Object.assign(authHeader(), {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        }),
    };

    return axios.get(process.env.REACT_APP_COORDINATOR_URL+"/api/clock/events/" + warehouse_id + "/" + start + "/" + end, requestOptions)
        .then(response => {
            return response.data.data;
        }, handleError);
}

function saveEvents(warehouse_id, events) {
    const requestOptions = {
        headers: Object.assign(authHeader(), {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        }),
    };

    return axios.post(process.env.REACT_APP_COORDINATOR_URL+"/api/clock/events", {
        warehouse_id,
        events
    }, requestOptions)
        .then(response => {
            return true;
        }, handleError);
}

function load(id) {
    const requestOptions = {
        headers: Object.assign(authHeader(),{'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*'}),
    };

    return axios.get(process.env.REACT_APP_COORDINATOR_URL+'/api/clock/'+id,  requestOptions)
        .then(response => {
            return response.data.data;
        }, handleError);
}

function save(id,clock) {
    const requestOptions = {
        headers: Object.assign(authHeader(),{'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*'}),
    };

    return axios.post(process.env.REACT_APP_COORDINATOR_URL+'/api/clock/'+id, clock,  requestOptions)
        .then(response => {
            return response.data.data;
        }, handleError);
}

function newClock(clock) {
    const requestOptions = {
        headers: Object.assign(authHeader(),{'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*'}),
    };
    return axios.post(process.env.REACT_APP_COORDINATOR_URL+'/api/clock/', clock,  requestOptions)
        .then(response => {
            return response.data.data;
        }, handleError);
}

function clockIn(body) {
    const requestOptions = {
        headers: Object.assign(authHeader(),{'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*'}),
    };

    return axios.post(process.env.REACT_APP_COORDINATOR_URL+'/api/clock/in', body , requestOptions)
        .then(response => {
            return response.data.data;
        }, handleError);
}

function clockOut() {
    const requestOptions = {
        headers: Object.assign(authHeader(),{'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*'}),
    };

    return axios.post(process.env.REACT_APP_COORDINATOR_URL+'/api/clock/out',{},  requestOptions)
        .then(response => {
            return response.data.data;
        }, handleError);
}

function loadAdminClocks(start,end) {
    const requestOptions = {
        headers: Object.assign(authHeader(),{'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*'}),
    };

    console.log('before request');

    return axios.post(process.env.REACT_APP_COORDINATOR_URL+'/api/clock/clocks',{start,end},  requestOptions)
        .then(response => {
            console.log('response', response.data);
            return response.data.data;
        }, handleError);
}




function handleError(error) {

    if (error.response && !(error.response.status >= 200 && error.response.status < 300)) {
        return Promise.reject(error.response.status);
    }

    return Promise.reject(500);

}



// WEBPACK FOOTER //
// ./src/scenes/Clock/reducer/api.js